import { render, staticRenderFns } from "./automation.vue?vue&type=template&id=fe42ecfa&scoped=true"
import script from "./automation.vue?vue&type=script&lang=js"
export * from "./automation.vue?vue&type=script&lang=js"
import style0 from "./automation.vue?vue&type=style&index=0&id=fe42ecfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe42ecfa",
  null
  
)

export default component.exports